<template>
  <section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: '/maintenances' }"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
    </header>
    <heim-card>
      <header class="header left">
        <h1>{{ $t('newMaintenance') }}</h1>
      </header>
      <main>
        <form @submit.prevent="handleForm">
            <div class="row">
                <span class="label">{{ $t('maintenance') }}</span>
                <div class="inputs">
                    <heim-input :label="$t('customer') + ' *'" name="name" :placeholder="$t('customer')" v-model="name" v-validate="'required'"></heim-input>
                     <span v-show="errors.has('name')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('name') }}</span>
                    <heim-select
                        :label="$t('techno')"
                        :data="types"
                        label-key="type"
                        value-key="id"
                        v-model="type_id"
                    ></heim-select>
                    <heim-input :label="$t('title') + ' *'" name="title" :placeholder="$t('title')" v-model="title" v-validate="'required|max:25'"></heim-input>
                    <span v-show="errors.has('title')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('title') }}</span>
                    <heim-select
                        :label="$t('manager')"
                        :data="users"
                        label-key="name"
                        value-key="id"
                        v-model="user_id"
                    ></heim-select>
                    <heim-input :label="$t('projectMantis')" name="mantis_id" :placeholder="$t('projectMantis')" v-model="mantis_id" type="number"></heim-input>
                    <heim-textarea :label="$t('description')" name="description" :placeholder="$t('description')" v-model="description"></heim-textarea>
                </div>
            </div>
            <div class="row">
              <span class="label">{{ $t('maintenanceCosts') }}</span>
              <div class="inputs">
                <div class="heim-input date-hosting">
                  <div class="date-h">
                    <span class="label">{{ $t('startDate') }}</span>
                    <datepicker 
                    type="date"
                    name="date_start"
                    input-class="paper-input"
                    wrapper-class="date-input"
                    v-model="date_start"
                    value-key="id"
                    :disabledDates="disabledDateStart(date_end)"
                    ></datepicker>
                  </div>
                  <div class="date-h">
                    <span class="label">{{ $t('endDate') }}</span>
                    <datepicker 
                    type="date"
                    name="date_end"
                    input-class="paper-input"
                    wrapper-class="date-input"
                    v-model="date_end"
                    value-key="id"
                    :disabledDates="disabledDateEnd(date_start)"
                    ></datepicker>
                  </div>
                </div>
                <heim-input
                  :label="$t('amount')"
                  name="amount"
                  type="number"
                  v-model="amount"
                  step="0.01"
                ></heim-input>
                <heim-input
                  :label="$t('numberDay')"
                  name="days"
                  type="number"
                  v-model="days"
                  step="0.01"
                ></heim-input>
              </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('siteAndApplication') }}</span>
            <div class="inputs">
              <heim-input :label="$t('nameWebsite')" name="name_website" :placeholder="$t('nameWebsite')" v-model="name_website"></heim-input>
              <heim-input :label="$t('prodWebsite')" name="prod_website" v-model="prod_website"></heim-input>
              <heim-input :label="$t('stagingWebsite')" name="staging_website" v-model="staging_website"></heim-input>
            </div>
          </div> 
          <footer>
            <heim-button :disabled="errors.any()" type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
  </section>
</template>

<script>
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimTextarea from "@/components/form/input/text/heim-textarea.vue";
import HeimSelect from "@/components/form/input/select/heim-select.vue";
import HeimSelect2 from "@/components/form/input/select/heim-select2.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import HeimIcon from "@/components/icon/heim-icon.vue";
import Datepicker from "vuejs-datepicker";

import { mapState } from "vuex";
export default {
  name: "MaintenancesNew",
  components: {
    HeimInput,
    HeimTextarea,
    HeimSelect,
    HeimSelect2,
    HeimButton,
    HeimCard,
    HeimIcon,
    Datepicker
  },
  mounted() {
    this.$store.dispatch("getUsers");
    this.$store.dispatch("getTypes");
    this.$store.dispatch("setTitle", "Create maintenance");
  },
  data() {
    return {
      name: "",
      type_id: "",
      description: "",
      title: "",
      date_start: "",
      date_end: "",
      mantis_id: "",
      user_id: "",
      days: "",
      amount: "",
      name_website: "",
      prod_website: "",
      staging_website: "",
    };
  },
  computed: {
    ...mapState({
      users: state => state.maintenancesState.users,
      types: state => state.maintenancesState.types
    })
  },
  methods: {
    async handleForm() {
      const data = await this.$store.dispatch("createMaintenance", {
        type_id: this.type_id,
        description: this.description,
        name: this.name,
        title: this.title,
        mantis_id: this.mantis_id,
        user_id: this.user_id,
        days: this.days,
        amount: this.amount,
        date_start: this.date_start,
        date_end: this.date_end,
        name_website: this.name_website,
        prod_website: this.prod_website,
        staging_website: this.staging_website,
      });

      this.$validator.validateAll().then(result => {
        if (result && data.id) {
          this.$store.dispatch("setToastMessage", {
            message: "newMaintenancecreated"
          });
          this.$store.dispatch("setToastMode", {});
          this.$store.dispatch("setOpenToast", { opened: true });
          this.$router.push({ path: `/maintenances/${data.id}/details` });
        }
      });
    },
    disabledDateStart(date) {
      return {
        from: new Date(date)
      };
    },
    disabledDateEnd(date) {
      return {
        to: new Date(date)
      };
    }
  }
};
</script>

<style>
input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}

.heim-input {
  max-width: 32em;
}

.heim-input input {
  width: 100%;
}

input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}
</style>

<style scoped>
.toggle-box {
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  display: flex;
  align-items: center;
}
.toggle-box .label {
  display: inline-block;
  margin-bottom: 0.6em;
}

.heim-input .label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}
</style>

<style scoped>
.heim-input {
  max-width: 32em;
}

.heim-input input {
  width: 100%;
}

.label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}
input.paper-input {
  background: var(--heim-grey-color) !important;
  width: 100% !important;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed !important;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}

.vdp-datepicker input {
  width: 100%;
}

.date-input {
  margin-bottom: 20px;
}

.date-input .paper-input {
  width: 100%;
}

.date-hosting {
  display: flex;
  flex-wrap: wrap;
}

.date-hosting .date-h {
  flex: 1;
  padding-right: 20px;
}

.date-hosting .date-h:last-child {
  padding-right: 0px;
}
</style>
